import React, { useEffect, useState } from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import TextField from "@mui/material/TextField";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

import dayjs from "dayjs";
import Button from "../../../components/common/button/Button";
import InputSelect from "../../../components/common/input/InputSelect";
import { useSelector } from "react-redux";
import callApi from "../../../services/api/apiClient";
import { Modal } from "@mui/material";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { useToast } from "../../../components/toast/Toast";

const CreateLiveSale = ({ onClose, isOpen, selectRoom, sessionList }) => {
  const roomList = useSelector((state) => state?.liveSale?.roomList)?.data;
  const warehouseList = useSelector(
    (state) => state?.transfer?.getWarehouseList
  )?.data;
  console.log(warehouseList, "warehouseList in create live sale");

  const navigate = useNavigate();
  const { showToast } = useToast();
  const [selectFromTime, setSelectFromTime] = useState(null);
  const [selectToTime, setselectToTime] = useState(null);
  // const [selectRoom, setSelectRoom] = useState(null)
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const [warehouse, setWarehouse] = useState("");
  const [selectedWarehouse, setSelectedWarehouse] = useState(null);
  const [packagingWarehouses, setPackagingWarehouses] = useState([]);

  // useEffect(() => {
  //     listSaleRoom()
  // }, [])

  // const listSaleRoom = () => {
  //     callApi('liveSale/roomList')
  //         .loadingGroup('LiveSale')
  //         .executeDispatch()
  // }
  useEffect(() => {
    getWarehouseList();
  }, []);

  const getWarehouseList = () => {
    callApi("transfer/getWarehouseList")
      .loadingGroup("warehouse")
      .execute()
      .then((res) => {
        const allWarehouses = res || [];
        const filtered = allWarehouses.filter(
          (wh) => wh?.warehouse?.is_packaging_warehouse === true
        );
        setPackagingWarehouses(filtered);
      });
  };
  const packagingWarehousesList = packagingWarehouses?.map((p) => p.warehouse);

  const handleFromTimeChange = (newTime) => {
    setSelectFromTime(newTime);
  };

  const handleToTimeChange = (newTime) => {
    setselectToTime(newTime);
  };

  const onCreateLiveSale = () => {
    const data = {
      date: dayjs(selectedDate).format("YYYY-MM-DD"),
      from: dayjs(selectFromTime).format("HH:mm:ss"),
      to: dayjs(selectToTime).format("HH:mm:ss"),
      live_sale_room_id: selectRoom,
      packaging_warehouse_id: selectedWarehouse?.id || "",
    };

    callApi("liveSale/createLiveSale")
      .withBody(data)
      .execute()
      .then((res) => {
        if (res?.status === "success") {
          navigate("/livesale/sessionList");
          onClose();
          sessionList(selectRoom?.value);
          showToast("Live Sale is successfully created!", "success");
        } else {
          console.log("ERROR", res?.error);
          showToast(res?.message, "error");
        }
      });
  };

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      className="flex items-center justify-center"
    >
      <div className="py-[30px] px-[37px] w-4/12  rounded-[16px] bg-white-0 overflow-y-scroll h-5/6">
        <h1 className="text-xl text-center">Create Live Sale</h1>
        {/* <form action="" onSubmit={formik.handleSubmit}> */}
        <div className="p-6">
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <h2 className="mb-3 text-base font-interSemiBold">
              Date <span className="text-red-0">*</span>
            </h2>
            <DatePicker
              className="w-full"
              format="DD/MM/YYYY"
              onChange={(newValue) => {
                const dateFormatted = new Date(newValue);
                setSelectedDate(newValue);
                console.log(
                  "Select date",
                  moment(dateFormatted).format("YYYY-MM-DD")
                );
                // setSelectedDate(moment(dateFormatted).format("YYYY-MM-DD"));
              }}
              value={selectedDate}
            />
            <div className={"mt-[12px]"}>
              <InputSelect
                name={"township"}
                data={packagingWarehousesList || []}
                label={"Township"}
                className={"w-full"}
                value={selectedWarehouse?.id || ""}
                onChange={(e) => {
                  const selected = packagingWarehousesList?.find(
                    (w) => w.id === e.target.value
                  );
                  setSelectedWarehouse(selected);
                }}
                placeholder="Select"
                required
              />
            </div>

            <div className="flex justify-between mt-5">
              <div>
                <h2 className="mb-3 text-base font-interSemiBold">
                  From Time <span className="text-red-0">*</span>
                </h2>
                <TimePicker
                  className="w-[95%]"
                  slots={{ openPickerIcon: ArrowDropDownIcon }}
                  value={selectFromTime}
                  onChange={handleFromTimeChange}
                  renderInput={(params) => <TextField {...params} />}
                />
              </div>
              <div>
                <h2 className="mb-3 text-base font-interSemiBold">
                  To Time <span className="text-red-0">*</span>
                </h2>
                <TimePicker
                  className="w-[100%]"
                  slots={{ openPickerIcon: ArrowDropDownIcon }}
                  value={selectToTime}
                  onChange={handleToTimeChange}
                  renderInput={(params) => <TextField {...params} />}
                />
              </div>
            </div>

            {/* <h2 className=' text-base font-interSemiBold mt-3'>Live Sale Room <span className='text-red-0'>*</span></h2>

                            <InputSelect
                                name={"saleRoom"}
                                data={roomList}
                                className={"w-full"}
                                value={selectRoom?.name}
                                onChange={(item) => setSelectRoom(item)}
                                placeholder="Select"
                            /> */}
          </LocalizationProvider>
          <Button
            onClick={() => onCreateLiveSale()}
            type={"submit"}
            className=" bg-blue-1 text-white-0 text-lg h-[48px] w-full 2xl:w-[240px] p-[8px] 2xl:p-[12px] rounded-[8px] lg:text-md 2xl:text-lg flex items-center justify-center mt-[20px] lg:mt-[30px]"
          >
            Create
          </Button>
        </div>
        {/* </form> */}
      </div>
    </Modal>
  );
};

export default CreateLiveSale;
